import {Injectable} from '@angular/core';
import {VexLayoutService} from '@vex/services/vex-layout.service';
import {NavigationItem} from './navigation-item.interface';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationLoaderService {
  private readonly _items: BehaviorSubject<NavigationItem[]> =
    new BehaviorSubject<NavigationItem[]>([]);

  get items$(): Observable<NavigationItem[]> {
    return this._items.asObservable();
  }

  constructor(private readonly layoutService: VexLayoutService) {
    this.loadNavigation();
  }

  loadNavigation(): void {
    this._items.next([
      {
        type: 'subheading',
        label: 'Dashboard',
        availableTo: ['STUDENT'],
        children: [
          {
            type: 'link',
            label: 'Home',
            route: '/home',
            icon: 'mat:home',
            routerLinkActiveOptions: {exact: true},
            availableTo: ['STUDENT']
          }
        ]
      },
      {
        type: 'subheading',
        label: 'General',
        availableTo: ['STUDENT'],
        children: [
          {
            type: 'link',
            label: 'Admit Card',
            icon: 'mat:featured_video',
            route: '/general/admit-card',
            availableTo: ['STUDENT'],
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Exams',
        availableTo: ['STUDENT'],
        children: [
          {
            type: 'link',
            label: 'Live',
            route: '/scheduled-exams/live',
            icon: 'mat:library_books',
            availableTo: ['STUDENT']
          },
          {
            type: 'link',
            label: 'Upcoming',
            route: '/scheduled-exams/upcoming',
            icon: 'mat:library_books',
            availableTo: ['STUDENT']
          },
          {
            type: 'link',
            label: 'Completed',
            route: '/scheduled-exams/completed',
            icon: 'mat:library_books',
            availableTo: ['STUDENT']
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Result',
        availableTo: ['STUDENT'],
        children: [
          {
            type: 'link',
            label: 'View Result',
            route: '/result',
            icon: 'mat:bar_chart',
            availableTo: ['STUDENT']
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Support Tickets',
        availableTo: ['STUDENT'],
        children: [
          {
            type: 'link',
            label: 'Add',
            route: '/support-ticket/add',
            icon: 'mat:bookmark',
            availableTo: ['STUDENT']
          },
          {
            type: 'link',
            label: 'List',
            route: '/support-ticket',
            icon: 'mat:subject',
            availableTo: ['STUDENT']
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Help & Support',
        availableTo: ['STUDENT'],
        children: [
          {
            type: 'dropdown',
            label: 'Help & Support',
            icon: 'mat:help',
            availableTo: ['STUDENT'],
            children: [
              {
                type: 'link',
                label: 'Introduction',
                route: '/help/introduction',
                icon: 'mat:help',
                availableTo: ['STUDENT']
              },
              {
                type: 'link',
                label: 'Login',
                route: '/help/login',
                icon: 'mat:account_circle',
                availableTo: ['STUDENT']
              },
              {
                type: 'link',
                label: 'Admit Card',
                route: '/help/admit-card',
                icon: 'mat:admin_panel_settings',
                availableTo: ['STUDENT']
              },
              {
                type: 'link',
                label: 'Exam',
                route: '/help/exam',
                icon: 'mat:access_time',
                availableTo: ['STUDENT']
              },
            ]
          },
        ]
      },
    ]);
  }
}
